import { useEffect } from "react";
import { AlertTriangle } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { DISCLAIMER } from "../data";

const POINTS = [
  {
    h: "Advisory Services Only",
    p: "JOBLSX provides consulting, account management guidance, profile audits, growth planning, and technical support. All services are advisory in nature and delivered in good faith based on available information.",
  },
  {
    h: "No Guaranteed Outcomes",
    p: "We do not guarantee account recovery, verification, reinstatement, policy exceptions, follower growth, revenue, or any outcome that is controlled by third-party platforms. Results depend on many factors outside our control.",
  },
  {
    h: "Platform Independence",
    p: "JOBLSX is an independent consultancy. We are not affiliated with, endorsed by, or partnered with any third-party platform. Our guidance references only publicly available platform features and policies.",
  },
  {
    h: "Client Responsibility",
    p: "Clients remain solely responsible for their accounts and for implementing recommendations in compliance with the applicable platform's terms of service and policies.",
  },
];

export default function Disclaimer() {
  useEffect(() => {
    document.title = "Disclaimer — JOBLSX";
  }, []);

  return (
    <div>
      <PageHeader
        overline="Legal"
        title="Disclaimer"
        subtitle="Please read this carefully to understand the scope and limits of our services."
      />
      <section className="pb-24 pt-8">
        <div className="mx-auto max-w-3xl px-6 md:px-12">
          <div className="mb-10 flex items-start gap-4 rounded-3xl border border-blue-500/20 bg-blue-600/[0.06] p-6">
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-blue-600/15 text-blue-400">
              <AlertTriangle className="h-5 w-5" />
            </div>
            <p className="leading-relaxed text-slate-300">{DISCLAIMER}</p>
          </div>

          <div className="space-y-10">
            {POINTS.map((s) => (
              <div key={s.h}>
                <h2 className="font-display text-2xl font-medium tracking-tight">{s.h}</h2>
                <p className="mt-3 leading-relaxed text-slate-400">{s.p}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
